import { Box, useClassNames } from '@factorialco/deprecated-design-system'

import { InjectHoverProvider, useHover } from 'modules/core/lib/hoverContext'

import 'modules/payroll_bundle/components/common/styles/index.styles.css'

const stylesRefs = {
  clickable: 'styles_clickable',
  hoverCell: 'styles_hoverCell',
  activeCell: 'styles_activeCell',
}

interface cellProps {
  value: string
  activeButton: string
  isActive: boolean
  isClickable: () => boolean
  onClick: () => void
}

const WorksheetCell = ({ value, activeButton, isActive, isClickable, onClick }: cellProps) => {
  const isHover = useHover()
  const cx = useClassNames(stylesRefs)

  return (
    <InjectHoverProvider>
      <Box
        className={cx({
          clickable: isClickable(),
          hoverCell: isHover && !!activeButton,
          activeCell: isActive,
        })}
        paddingY="s12"
        paddingX="s16"
        onClick={onClick}
      >
        <Box className={'styles_cellValue'}>{value}</Box>
      </Box>
    </InjectHoverProvider>
  )
}

export default WorksheetCell
